export const ApplicationDeadline = ({ shorten = false }) => {
  return (
    <p className="application-deadline">
      {shorten ? null : "Application"} Deadline: April 1,{" "}
      {new Date().getFullYear()}
    </p>
  );
};
